import styled, { css } from 'styled-components';
import { colors, dimensions, typography } from '../common/styles';
import { lighten } from '../common/styles/color';
import { twinkling } from 'modules/common/utils/animations';

const UserHelper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

const Layout = styled.main`
  height: 100%;
  display: flex;
  flex: 1;
  max-width: 100%;
  background: #ebebff;
`;

const MainWrapper = styled.div`
 width:100%;

@media (max-width: 760px)
{
  // display: block;
 // padding-left: 19px;

}

`;

const SectionBody = styled.div`
  i {
    color: ${colors.colorCoreLightGray};
    &:hover {
      cursor: pointer;
    }
  }
`;

const Contents = styled.div`
    background: #F9F9F9;
    margin-left: ${(props) => props.marginLeft == 'none' ? 0 : 70}px;
    border-radius: 30px 0px 0px 30px;
    position: relative;
    z-index: 10;
    min-height: 100%;
    height:100%;
    overflow: hidden;


  @-moz-document url-prefix() {
    overflow: hidden;
  }

  @media (max-width: 768px) {
    overflow-x: hidden;
    // z-index: 10 !important;
    //padding-left: 26px;
    margin-left:0;
    border-radius: 0;
  }
`;

const MainContent = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 475px;
  max-height: 90vh;
  max-height: calc(100vh - 70px);
  overflow-y:auto;
  // border-radius: 20px;
  // box-shadow: ${props =>
    !props.transparent && `0 0 8px 1px ${colors.shadowPrimary}`};
  //margin-right: ${dimensions.coreSpacing}px;
  // background: ${colors.colorCoreRed};
  // background-color: ${props => !props.transparent && colors.colorWhite};

  // @media (min-width: 760px) and (max-width: 1040px)
  // {
  //  margin-right: -258px
  // }

  @media (max-width: 760px) {
    overflow: auto;
    min-width: -webkit-fill-available;
  }

  @media (max-width: 639px) {
    max-height: calc(100vh - 0px);
  }
  
`;

const ContentSpace = styled.div`
  padding: ${dimensions.coreSpacing}px;
`;

const ContentBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  // overflow: auto;
  overflow: ${props => !props.overflow && 'inherit'};
  overflow: auto;
  position: relative;
  // background-color: ${props => !props.transparent && colors.colorWhite};
  // background: #fff;
  // border-bottom-left-radius: 20px;
  // border-bottom-right-radius: 20px;
  // border-radius: 20px;
  // padding: 15px;
`;

const ContentHeader = styled.div`
  // background: ${props =>
    props.background === 'transparent' ? 'none' : colors[props.background]};
  // background: #eef3fa;
  min-height: ${dimensions.headerSpacing}px;
  // border-top-left-radius: 20px;
  // border-top-right-radius: 20px;
  border-bottom: ${props => props.showBorderBottom === true ? '2px solid #F2F2F2' : 'none'};
  display: flex;
  justify-content: space-between;
  padding: 12px 25px;
  // margin: 20px;
  // border-radius: 9px;


  // label {
  //   color: ${colors.themeBlack};
  //   margin: 0px;
  //   font-size: 12px;
  //   font-weight: 700;
  //   letter-spacing: 0.5px;
  // }
`;

export const MainArea = styled.div`

  // background: #fff;
  background-color: ${props => !props.transparent && colors.colorWhite};
  box-shadow: ${props =>
    !props.transparent && `0px 4px 24px rgb(0 0 0 / 5%)`};
  border-radius: 20px;
  //margin: 20px;
  overflow: ${props => props.overflow ? props.overflow : 'auto'};
  @media only screen and (max-width: 767px) {
    //margin: 10px;
  }
`;

const ContentHeaderData = styled.div`
  display:flex;
  //margin:30px 30px;
  align-items:center;
  margin-top: 30px;
  margin-bottom: 15px;

  justify-content:space-between;

  label {
    color: ${colors.themeBlack};
    margin: 0px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  @media screen and (max-width: 767px){
    margin: 0px 20px;
    padding-top: 33%;
  }


`;

export const ContentHeading = styled.div`
  min-height: 50px;
  margin: 15px;
  border-radius: 9px;

  > label, h6, .campaign-heading > label {
    line-height: 49px;
    font-size: 36px;
    font-weight: 700;
    margin-top: 12px;
    color: #2B3C93;
    letter-spacing: 0.1em;
    margin: 0;
    height: auto;
    display: inline-flex;
    text-transform: uppercase;
    // margin-left: 25px;
  }
  @media (max-width: 767px) {
    > label, h6 {
      font-size: 22px !important;
      // margin-top: 25% !important;
      margin-left: 10px !important;
    }
  }


`

const ContenFooter = styled.div`
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  // padding: 15px;
  ${ContentHeader} {
    border-bottom: none;
    border-top: 1px solid ${colors.borderPrimary};
  }
`;

const BarItems = styled.div`
  > * + * {
    margin-left: ${dimensions.unitSpacing}px;
  }

  input[type='text'] {
    width: auto;
    display: inline-block;
  }
`;

const HeaderItems = styled.div`
  align-self: center;
  margin-left: ${props => props.rightAligned && 'auto'};
`;

const SideContent = styled.section`
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  border-radius: 10px;
  width: ${props => (props.wide ? '360px' : '300px')};
  flex: ${props => (props.half ? '1' : 'none')};
  margin-right: ${dimensions.coreSpacing}px;
  background: ${props => (props.full ? colors.colorWhite : 'none')};
  box-shadow: ${props =>
    props.full ? `0 0 8px 1px ${colors.shadowPrimary}` : 'none'};
`;

const SidebarHeader = styled.div`
  background-color: ${colors.bgLight};
  height: ${dimensions.headerSpacing}px;
  border-radius: 10px 10px 0px 0px;
  // margin: 5px;
  margin-bottom: ${props => props.spaceBottom && '10px'};
  align-items: center;
  padding: 0 ${dimensions.coreSpacing}px 0 ${dimensions.coreSpacing}px;
  border-bottom: 1px solid ${colors.borderPrimary};
  text-transform: ${props => props.uppercase && 'uppercase'};
  // font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  font-weight: 500;
  display: flex;
  font-size: ${typography.fontSizeHeading8}px;
  flex-direction: row;
  justify-content: space-between;
  color: ${colors.colorPrimary}
`;

const SidebarTitle = SidebarHeader.withComponent('h3').extend`
  padding: 0 ${dimensions.coreSpacing}px;
  margin: 0 0 -1px 0;
  text-transform: uppercase;
`;

const SidebarMainContent = styled.div`
  overflow: hidden auto;
  flex: 1;
  position: relative;
`;

const SidebarFooter = SidebarHeader.extend`
  border-top: 1px solid ${colors.borderPrimary};
  border-bottom: none;
`;

const SidebarBox = styled.div`
  border-radius: 5px;
  background-color: ${props => (props.noBackground ? '' : colors.colorWhite)};
  margin-bottom: ${dimensions.coreSpacing}px;
  box-shadow: ${props =>
    props.noShadow ? 'none' : `0 0 8px 1px ${colors.shadowPrimary}`};
  padding-bottom: ${props =>
    props.collapsible ? `${dimensions.unitSpacing}px` : '0'};
  position: ${props => (props.full ? 'initial' : 'relative')};
  justify-content: center;
  transition: max-height 0.4s;
  overflow: ${props => (props.collapsible ? 'hidden' : 'initial')};
  display: ${props => props.full && 'flex'};

  &:last-child {
    margin-bottom: 30px;
  }
`;

const BoxContent = styled.div`
  flex: 1;

  ul {
    padding: 5px 0;
  }
`;

const SidebarToggle = styled.a`
  width: 100%;
  color: ${colors.colorCoreGray};
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 2px 0;
  font-size: 10px;
  background: ${colors.bgLight};
  border-top: 1px solid ${colors.borderPrimary};

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }
`;

const HelperButtons = styled.div`
  position: absolute;
  right: ${dimensions.coreSpacing}px;
  top: 15px;
  color: ${colors.colorCoreLightGray};

  a {
    float: left;
    color: ${colors.colorCoreLightGray};
    text-transform: none;
    cursor: pointer;
    margin-left: ${dimensions.unitSpacing}px;
    font-size: ${typography.fontSizeHeading8}px;
    font-weight: ${typography.fontWeightLight};
    outline: 0;

    > i {
      font-size: 14px;
      margin-right: 0;

      &:hover {
        color: ${colors.colorCoreBlack};
      }
    }
  }
`;

const FieldStyle = styled.div`
  white-space: nowrap;
  overflow: ${props => (props.overflow ? props.overflow : 'hidden')};
  text-overflow: ellipsis;
  flex: 1;
`;

const SidebarList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li.child-segment {
    border-bottom: none;
    background-color: ${colors.bgLight};

    > span {
      background-color: ${colors.bgLight};
      box-shadow: -2px 0 10px 2px ${colors.bgLight};
    }
  }

  &.no-link li,
  a {
    display: block;
    padding: 6px 20px;
    color: ${colors.textPrimary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    outline: 0;
    position: relative;
    border-left: 2px solid transparent;
    transition: background 0.3s ease;

    > i {
      margin-right: 5px;
    }

    &:hover,
    &.active {
      cursor: pointer;
      background: ${colors.bgActive};
      text-decoration: none;
      outline: 0;
      color: ${lighten(colors.textPrimary, 40)};
    }

    &.active {
      border-left: 2px solid ${colors.colorPrimary};
    }
  }

  div {
    &.active {
      cursor: pointer;
      background: ${colors.bgActive};
      text-decoration: none;
      outline: 0;
      color: ${lighten(colors.textPrimary, 40)};
    }

    &.active {
      border-left: 2px solid ${colors.colorPrimary};
    }
  }

  .icon {
    margin-right: 6px;
    color: ${colors.colorCoreGray};
  }
`;

const SidebarCounter = styled.span`
  font-size: ${typography.fontSizeHeading}px;
  text-align: ${props => (props.nowrap ? 'left' : 'right')};
  color: ${colors.colorCoreGray};
  margin-top: 2px;
  position: ${props => !props.nowrap && 'absolute'};
  right: ${dimensions.coreSpacing}px;
  max-width: ${props => (props.nowrap ? '100%' : '60%')};
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: ${props => (props.nowrap ? '0' : '10px')};

  a {
    padding: 0;
    color: ${colors.linkPrimary};
  }

  span {
    float: right;
    margin-left: 5px;
  }

  ${props =>
    props.nowrap &&
    css`
      display: block;
      white-space: normal;
    `};
`;

const FlexContent = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
`;

const FlexItem = styled.div`
  flex: ${props => (props.count ? props.count : 1)};
  position: relative;
`;

const FlexRightItem = styled.div`
  margin-left: auto;
`;

const WhiteBoxRoot = styled.div`
  margin-bottom: ${dimensions.coreSpacing}px;
  background-color: ${colors.colorWhite};
  box-shadow: 0 0 8px 1px ${colors.shadowPrimary};
`;

const WhiteBox = WhiteBoxRoot.extend`
  flex: 1;
  overflow: auto;
  position: relative;
`;

const Authlayout = styled.div`
  height: 100%;
  // overflow: hidden;
  position: relative;
  flex: 1;

  // Forgot Password Disabled due to this appearing in between
  // &:before {
  //   content: '';
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  // }


  .bgRow {
    height: 90%;
    display: flex;
    margin-top: -30px;

    @media (max-width: 768px) {
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .row {
    display: flex;
    align-items: strech;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;

const AuthDescription = styled.div`
  @media (max-width: 768px) {
    text-align: center;
    display: none;
  }

  h1 {
    font-weight: bold;
    font-size: 26px;
    margin-bottom: 20px;
    color: #212121;
    margin-top: 10px;
  }
  p {
    color: #95959d;
    margin-bottom: 50px;
    font-size: 16px;
    letter-spacing: 1px;
  }
  a {
    color: rgba(255, 255, 255, 0.7);
  }
  .not-found {
    margin-top: 0;
  }

  .rightmain-content{

  }
`;

const Links = styled.div`
  color: #303030;
  margin-bottom: 0px;
  font-size: 16px;
  text-align: justify;
  font-weight: 600;
  margin-bottom: 100px;

  a {
    color: #364aae;
    font-weight: 600;
  }

`;

const ResponsiveHideComponent = styled.div`

  ${({ hideOnSmallScreen }) =>
    hideOnSmallScreen &&
    css`
      @media (max-width: 1090px) {
        display: none !important;
      }
    `}
`;

export {
  Layout,
  MainWrapper,
  Contents,
  MainContent,
  ContentBox,
  ContenFooter,
  ContentHeader,
  ContentSpace,
  HeaderItems,
  BarItems,
  SideContent,
  SidebarHeader,
  SidebarMainContent,
  SidebarFooter,
  BoxContent,
  SidebarToggle,
  SidebarCounter,
  HelperButtons,
  SidebarTitle,
  UserHelper,
  SidebarList,
  FieldStyle,
  SidebarBox,
  FlexContent,
  FlexItem,
  SectionBody,
  FlexRightItem,
  WhiteBoxRoot,
  WhiteBox,
  Authlayout,
  AuthDescription,
  Links,
  ContentHeaderData,
  ResponsiveHideComponent
};



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/styles.js